(function($){
    $(document).ready(function() {
        $(".js-mark-caption").mark($(".js-mark-caption").text(),{
            debug : false,
            diacritics: false,
            separateWordSearch: false
        });
    });
})(jQuery);

